<template>
  <section class="careers-team text-center relative locked">
    <div class="careers-team__people grid justify-center relative">
      <img
        v-for="mate in 14"
        :key="`team-${mate}`"
        :src="require(`../images/team/${mate}.webp`)"
        :class="`careers-team__people-image careers-team__people-image--${mate}`"
        alt="Bravado Team"
        decoding="async"
        height="84"
        width="84"
      />
    </div>
    <div class="page-container relative">
      <h1 class="careers-team__title">
        We&nbsp;help salespeople find their dream jobs&nbsp;&mdash;
        <span class="careers-team__title-overlay">join Bravado</span>
        to&nbsp;find yours
      </h1>
      <p class="careers-team__subtitle">
        Bravado is&nbsp;dedicated to&nbsp;helping salespeople build the careers they deserve. We&rsquo;re expanding our
        team rapidly to&nbsp;meet unprecedented demand across the entire sales community. We&rsquo;re on&nbsp;a&nbsp;big
        mission, and we&nbsp;need your help to&nbsp;get it&nbsp;done.
      </p>

      <BravadoButtonV3
        data-test="careers-page-open-roles-button"
        href="https://boards.greenhouse.io/bravado"
        target="_blank"
        size="lg"
        rel="nofollow"
      >
        <span class="px4">View open roles</span>
      </BravadoButtonV3>

      <div class="careers-team__meet justify-center pt9">
        <img
          :src="require('../images/people/1.webp')"
          class="careers-team__meet-image careers-team__meet-image--1"
          decoding="async"
          loading="lazy"
          width="354"
          height="216"
          alt="Bravado Meet"
        />
        <img
          :src="require('../images/people/2.webp')"
          class="careers-team__meet-image careers-team__meet-image--2"
          decoding="async"
          loading="lazy"
          width="264"
          height="303"
          alt="Bravado Meet"
        />
        <img
          :src="require('../images/people/3.webp')"
          class="careers-team__meet-image careers-team__meet-image--3"
          decoding="async"
          loading="lazy"
          width="454"
          height="303"
          alt="Bravado Meet"
        />
        <img
          :src="require('../images/people/4.webp')"
          class="careers-team__meet-image careers-team__meet-image--4"
          decoding="async"
          loading="lazy"
          width="354"
          height="199"
          alt="Bravado Meet"
        />
        <img
          :src="require('../images/people/5.webp')"
          class="careers-team__meet-image careers-team__meet-image--5"
          decoding="async"
          loading="lazy"
          width="354"
          height="418"
          alt="Bravado Meet"
        />
        <img
          :src="require('../images/people/6.webp')"
          class="careers-team__meet-image careers-team__meet-image--6"
          decoding="async"
          loading="lazy"
          width="365"
          height="237"
          alt="Bravado Meet"
        />
        <img
          :src="require('../images/people/7.webp')"
          class="careers-team__meet-image careers-team__meet-image--7"
          decoding="async"
          loading="lazy"
          width="353"
          height="237"
          alt="Bravado Meet"
        />

        <div class="careers-team__meet-copy text-left">
          <h2 class="careers-team__meet-title">
            Life at Bravado is pretty special.
            <br />
            It’s just missing you
          </h2>
          <p class="careers-team__meet-text">
            We’re invested in our people. Our culture is nimble and collaborative, with a fully-remote team around the
            world, working together to solve some of the biggest problems in sales.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'CareersTeam',
  components: { BravadoButtonV3 },
});
</script>

<style lang="scss" scoped>
.careers-team {
  padding: 0 0 70px;
  z-index: 1;

  @include mq('sm') {
    padding: 35px 0 0;
  }

  &__title {
    color: #161a21;
    max-width: 90%;
    margin: 0 auto 26px;

    @include mq('sm') {
      max-width: 880px;
      margin: 0 auto 24px;
    }

    @include bravado-h1;

    line-height: 1.2;

    span {
      background: linear-gradient(95.64deg, #515c9f 32.19%, #704464 59.22%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      //background-clip: text;
      //text-fill-color: transparent;
    }

    &-overlay {
      display: inline-block;

      @include mq('sm') {
        display: inline;
      }
    }
  }

  &__subtitle {
    color: #19191a;
    max-width: 830px;
    margin: 0 auto 20px;

    @include body;

    line-height: 1.6;

    @include mq('sm') {
      margin: 0 auto 30px;

      @include bravado-super-headline;
    }
  }

  &__meet {
    margin: 28px 0 0;
    justify-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    grid-gap: 12px;

    @include mq('sm') {
      display: grid;
      grid-gap: 8px;
      grid-template-columns: 354px 264px 93px 353px;
      grid-template-rows: 216px 79px 112px 173px 237px;
      grid-template-areas:
        'meet-img-1 meet-img-2 meet-img-3 meet-img-3'
        'meet-img-4 meet-img-2 meet-img-3 meet-img-3'
        'meet-img-4 meet-copy meet-copy meet-copy'
        'meet-img-5 meet-copy meet-copy meet-copy'
        'meet-img-5 meet-img-6 meet-img-6 meet-img-7';
      margin-top: 54px;
    }

    &-image {
      border-radius: 12px;
      width: 100%;
      height: 100%;

      &--1 {
        order: 1;
        grid-area: meet-img-1;
      }

      &--2 {
        display: none;
        grid-area: meet-img-2;

        @include mq('sm') {
          display: block;
        }
      }

      &--3 {
        order: 4;
        grid-area: meet-img-3;
      }

      &--4 {
        order: 2;
        grid-area: meet-img-4;
      }

      &--5 {
        display: none;
        grid-area: meet-img-5;

        @include mq('sm') {
          display: block;
        }
      }

      &--6 {
        order: 6;
        grid-area: meet-img-6;
      }

      &--7 {
        order: 5;
        grid-area: meet-img-7;
      }
    }

    &-copy {
      order: 3;
      color: #161a21;
      grid-area: meet-copy;
      border-radius: 12px;
      padding: 32px 27px 27px;
      background: url('~@/components/partials/landings/careers/images/bg/meet-bg.webp') no-repeat center top;
      background-size: cover;
    }

    &-title {
      margin-bottom: 10px;

      @include bravado-h4;

      @include mq('sm') {
        margin-bottom: 24px;

        @include bravado-h3;
      }
    }

    &-text {
      @include body;

      line-height: 1.6;

      @include mq('sm') {
        @include bravado-super-headline;
      }
    }
  }

  &__people {
    margin: 40px 0 60px -32px;
    gap: 10px;
    grid-template-columns: repeat(14, 1fr);
    justify-content: flex-start;

    @include mq('sm') {
      margin: 50px 0 70px;
      gap: 32px;
      justify-content: center;

      &::before,
      &::after {
        content: '';
        position: absolute;
        height: 100%;
        width: 356px;
        top: 0;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.75) -2.69%, rgba(255, 255, 255, 0) 100%);
      }

      &::before {
        left: 0;
      }

      &::after {
        right: 0;
        transform: rotate(-180deg);
      }
    }

    &-image {
      border-radius: 6px;
      height: 50px;
      width: 50px;

      &--2,
      &--4,
      &--6,
      &--9,
      &--11,
      &--13 {
        margin-top: 16px;
      }

      &--1,
      &--5,
      &--10,
      &--14 {
        margin-top: 32px;
      }

      @include mq('sm') {
        border-radius: 12px;
        height: 84px;
        width: 84px;

        &--2,
        &--4,
        &--6,
        &--9,
        &--11,
        &--13 {
          margin-top: 32px;
        }

        &--1,
        &--5,
        &--10,
        &--14 {
          margin-top: 64px;
        }
      }
    }
  }
}
</style>
